import { useMutation, useQuery } from 'react-query';
import devicesServices from './devices.services';
import notificationError from '@/utils/functions/notificationError';
import { queryClient } from '@/Root';
import { notification } from 'antd';
import { StoneDeviceListRequest } from './devices.types';
import { AxiosError } from 'axios';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

export function useStoneDeviceList(
  params: StoneDeviceListRequest,
  enabled = true,
) {
  const queryKey = ['stoneDevice/list', { ...params }];
  const cache = queryClient.getQueryData(queryKey);

  return useQuery(queryKey, () => devicesServices.list(params), {
    retry: 0,
    enabled:
      !cache &&
      enabled &&
      !!params.companyId &&
      hasPermissions([Authorities.STONE_MANAGER]),
    onError(err: AxiosError) {
      if (err.response?.status !== 404) {
        notificationError(err);
      }
    },
  });
}

export function useStoneDeviceCreate() {
  return useMutation(devicesServices.create, {
    async onSuccess() {
      notification.success({
        message: 'Dispositivo cadastrado!',
        description: 'O dispositivo da stone foi cadastrado com sucesso!',
      });
      await queryClient.invalidateQueries(['stoneDevice/list']);
    },
    onError(err) {
      notificationError(err);
    },
  });
}

export function useStoneDeviceUpdate() {
  return useMutation(devicesServices.update, {
    async onSuccess() {
      notification.success({
        message: 'Dispositivo atualizado!',
        description: 'O dispositivo da stone foi atualizado com sucesso!',
      });
      await queryClient.invalidateQueries(['stoneDevice/list']);
    },
    onError(err) {
      notificationError(err);
    },
  });
}

export function useStoneDeviceRemove() {
  return useMutation(devicesServices.remove, {
    async onSuccess() {
      notification.success({
        message: 'Dispositivo removido!',
        description: 'O dispositivo da stone foi removido com sucesso!',
      });
      await queryClient.invalidateQueries(['stoneDevice/list']);
    },
    onError(err) {
      notificationError(err);
    },
  });
}
